import { render, staticRenderFns } from "./IconUnlock.vue?vue&type=template&id=22d535aa&"
import script from "./IconUnlock.vue?vue&type=script&lang=ts&"
export * from "./IconUnlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports